<template>
	<div>
		<vAlert
			theme="info"
		>Container receiving time of  warehouse: Monday~Friday AM 8:30~PM 2:00. Accept drop unload.Or please contact Account Manager for liveunload.</vAlert>
        <!-- <template slot="footer"> -->
            <div class="margin-bottom-10">
                <Tooltip v-for="(item,index) in getReserAuthList" placement="top" v-show="item.showtitle" :key="index" :content="item.contenttitle">
                    <vButton
                        v-show="item.show"
                        :key="item.operate"
                        class="margin-right-15"
                        :theme="item.theme"
                        @click="submit(item.operate)"
                    >{{item.label}}</vButton>
                </Tooltip>
                <vButton
                    v-for="item in getReserAuthList"
                    v-show="item.show && !item.showtitle"
                    :key="item.operate"
                    class="margin-right-15"
                    :theme="item.theme"
                    @click="submit(item.operate)"
                >{{item.label}}</vButton>
                <vButton class="margin-right-15" @click="cancel">Return</vButton>
            </div>
			<!-- </template> -->
		<compWrapper title="Basic Information" theme="primary">
			<compFormQuery :labelWidth="160" class="margin-top-15" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="Inbound Information" theme="primary">
			<compFormQuery
				:labelWidth="160"
				class="margin-top-15"
				:formdata="getWareInfo"
				v-model="formData"
                placeholder="--"
			></compFormQuery>
		</compWrapper>
		<compWrapper title="Feedback Information" theme="primary">
			<compFormQuery
				:labelWidth="160"
				class="margin-top-15"
				:formdata="getFeedbackInfo"
				:value="formData"
                placeholder="--"
			></compFormQuery>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
        
		<!-- <compModal
			v-model="operate.show"
			isRequest
			v-bind="operate"
			@on-close="operate={}"
			@on-confirm="getDetail"
		></compModal> -->

        <!-- 公共弹框 -->
        <compModal
			v-model="operate.show"
			v-bind="operate"
            @on-close="operate={}"
            @on-confirm="getDetail"
		>
            <component ref="cusref" :is="operate.component"
             v-bind="operate" v-on="operate.on"
              @on-close="operate={}"></component>
        </compModal>

		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
// import { mapState, mapGetters } from "vuex";
import { HttpBespeak, HttpCancelBespeak, HttpManageCancelBespeak, HttpArrivedBespeak, HttpRefuseBespeak, HttpDischargeBespeak, HttpBespeakUpdate, HttpSubBespeak, HttpBespeakLog, HttpDeliverBespeak, HttpPickupDate } from "@/service/bespeak";

import compApprove from './reservation/approve.vue'

export default {
    props:['activeid','querytype','orgName'],
	components: {
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
        compApprove,
	},
	data() {
		return {
			operate: {
				show: false,
			},
			loading: false,
			id: this.$route.query.id || this.activeid,
			orgRoleName: this.$route.query.orgRoleName || this.orgName,
			calculateList: [],
			formData: {
				deliverDate: null
			},
			logList: [],
			lang: "en"
		};
	},
	created() {
        this.showPick = this.handleAuth('fbb.reserveinbound.obtainEmptyContainerDate');
		this.getDetail();
	},
	computed: {
		getReserAuthList() {
			const { status, deliverDate,bookingType } = this.formData,
				agent = this.orgRoleName === 'FORWARDER',
				custom = this.orgRoleName === 'MERCHANT',
				manage = this.orgRoleName === 'WAREHOUSE',
                supertype = this.orgRoleName === 'SUPER';
			return [{
				label: 'Cancel',
				operate: 'cancel',
				show: (status == 1 || status == 2 || status == 3) && (agent || custom),
                theme: "warning",
                showtitle:false,
			}, {
				label: 'Cancel',
				operate: 'manageCancel',
				show: (status == 2 || status == 3) && (manage || supertype),
                theme: "warning",
                showtitle:false,
			}, {
				label: 'Approve',
				operate: 'confirm',
				show: status == 1 && (manage || supertype) && bookingType==0,
                theme: "success",
                showtitle:false,
			}, {
				label: 'ECPD',
				operate: 'pickup',
				show: status == 4 && (manage || supertype) && this.showPick,
				theme: "warning",
                showtitle:true,
                contenttitle:'Empty Container Pick Up Date'
			}, {
				label: 'Reject',
				operate: 'reject',
				show: status == 1 && (manage || supertype) && bookingType==0,
				theme: "error",
                showtitle:false,
			}, {
				label: 'Unloaded',
				operate: 'discharge',
				show: (status == 6) && (manage || supertype),
				theme: "info",
                showtitle:false,
			}, 
            {
				label: 'Arrived',
				operate: 'arrived',
				show: this.handleAuth('fbb.reserveInbound.arrive') && (status == 2 || status == 3 || status == 4),
				theme: "info",
                showtitle:false,
			}, 
            // {
			// 	label: 'Delivered',
			// 	operate: 'Delivered',
			// 	show: (status == 2 || status == 4 || status == 6) && (agent || custom) && !deliverDate,
			// 	theme: "success",
            //     showtitle:false,
			// }, 
            {
				label: 'Submit',
				operate: 'submit',
				show: status == 0 && (agent || custom),
				theme: "info",
                showtitle:false,
			}]
		},
		getStatusMap() {
			return {
				'0': 'Draft',
				'1': 'Pending',
				'2': 'Approved',
				'3': 'Rejected',
				'4': 'Unloaded',
				'5': 'Cancelled',
                '6': 'Arrived'
			}
		},
		getContainerTypes() {
			return {
				'1': '20GP',
				'2': '40GP',
				'3': '40HQ',
				'4': '45HQ',
			}
		},
		getBase() {
			const { status, inboundType, orgWarehouseCode, warehouseTitle } = this.formData;
			return [{
				label: 'Reservation No.',
				key: 'reserveInboundNo',
                render:()=>{
                    return <div >{this.formData.reserveInboundNo}<img v-show={this.formData.yqnFlag == 1} style="width:20px;display:inline-block" class="margin-left-10" src="/img/yqnlogo.png"></img></div>
                }
			}, {
				label: 'Status',
				valueText: this.getStatusMap[status],
			}, {
				label: 'Inbound Plan No.',
				key: 'inboundNos'
			}, 
            {
				label: 'Document Type',
                valueText:this.formData.bookingType == 0 ?'<span class="color-success">VAS</span>':'<span class="color-primary">Nomal</span>'
			}, 
            {
				label: 'Inbound Type',
				key: 'inboundType',
				valueText: inboundType == 1 ? 'Transfer' : 'Purchase',
			}, 
            {
                label: "Cargo Form",
                key: "goodTypeName",
            },
            // 展示费备用日期
            {
                label: 'Delivery Time',
                valueText:this.formData.clientRequestDate?this.formData.clientRequestDate:'--'+' '+this.formData.startTime+'-'+this.formData.endTime,
            },
            {
				label: 'Warehouse',
				valueText: `${warehouseTitle}(${orgWarehouseCode})`
			},
            // 查看页面展示备用日期
            {
                label: 'Second Delivery Time',
                valueText:this.formData.secondClientRequestDate+' '+this.formData.startTime+'-'+this.formData.endTime,
                show:this.formData.bookingType == 0
            },
            {
				label: 'Project',
				key: 'lineNames'
			}, {
				label: 'Remark',
				key: 'remark'
			}, {
				label: 'CC',
				key: 'carbonCopy',
			}, {
				label: 'Shipment ID',
				key: 'shipmentId',
                show:this.formData.shipmentId!=''
			}]
		},
		//入库信息
		getWareInfo() {
			const { goodTypeCode } = this.formData;
			if (goodTypeCode === 'LTL') return this.getWareLitInfo
			if (goodTypeCode === 'Express') return this.getWareExpressInfo
			return this.getWareFclInfo
		},
		getWareFclInfo() {
			const { containerType } = this.formData;
			return [
				{
					label: "Cargo Form",
					key: "goodTypeName",
				},
				{
					label: 'Container Type',
					key: 'containerType',
					valueText: this.getContainerTypes[containerType]
				}, {
					label: 'Container No.',
					key: 'containerNo',
				}, {
					label: 'Port Arrived Date',
					key: 'arriveDate'
				}, {
					label: 'LFD of demurrage',
					key: 'lfdDemurrage',
				}, {
					label: 'LFD of detention',
					key: 'lfdDetention',
				},
				{
					label: 'Client Request Date',
					key: 'clientRequestDate',
				},
				{
					label: 'Carton QTY',
					key: 'totalCartonCount',
				}, {
					label: 'Volume(CBM)',
					key: 'totalVolume',
				}, {
					label: 'Truck Company',
					key: 'truckCompany',
				}, {
					label: 'License Plate No.',
					key: 'plateNo',
				}
			];
		},
		getWareLitInfo() {
			return [
				
				{
					label: 'Pallet QTY',
					key: 'trayCount',
				}, {
					label: 'BOL',
					key: 'bol',
				}, {
					label: 'Carton QTY',
					key: 'totalCartonCount',
				}, {
					label: 'Volume(CBM)',
					key: 'truckCompany',
				}, {
					label: 'Truck Company',
					key: 'truckCompany',
				}, {
					label: 'License Plate No.',
					key: 'plateNo',
				},
				{
					label: 'Client Request Date',
					key: 'clientRequestDate',
				},
			];
		},
		getWareExpressInfo() {
			return [
				{
					label: "Cargo Form",
					key: "goodTypeName",
				},
				{
					label: 'Express Company',
					key: 'courierCompany'
				}, {
					label: 'Tracking',
					key: 'tracking'
				},
				// {
				// 	label: 'Client Request Date',
				// 	key: 'clientRequestDate',
				// },
			];
		},
		//仓库反馈信息
		getFeedbackInfo() {
			const { status, deliverDate } = this.formData,
				list = [
					{
						label: "Scheduled Delivery Time",
						key: "reserveInboundDate",
					}, {
						label: "Loading Dock",
						key: "loadingDock"
					}, {
						label: "Approval Remark",
						key: "approvalRemark"
					}, {
						label: "Delivered Date",
						key: "deliverDate",
						show: !!deliverDate
					}
				];
			if (status == 2) return list;
			if (status == 3) return [{
				label: "Reject Reason",
				key: "refuseRemark"
			}];
			if (status == 4) return [...list, {
				label: "Container Empty Time",
				key: "containerEmptyTime"
			}, {
				label: "Unload Remark",
				key: "dischargeRemark"
			}];
			return [];
		},
	},
	methods: {
        closemodalprops(){
            this.$emit('on-openCloseable');

            this.operate = {};
        },
		cancel() {
            if(this.activeid){
                this.$emit('on-close')
            } else this.$router.push({ name: this.$route.name.slice(0, -5) })
		},
		async getLog() {
			HttpBespeakLog({
				'search[EQ_systemId]': this.id,
				'search[EQ_opModel]': 'ReserveInbound'
			}).then(res => {
				this.logList = res.data || [];
			});
		},
		async getDetail() {
			this.loading = true;
			this.getLog();
			HttpBespeak({
				id: this.id,
				orgRoleName: this.orgRoleName
			}).then(res => {
				const data = res.data || {};
				this.formData = data;
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		submit(type) {
			const id = this.id, orgRoleName = this.orgRoleName, goodTypeCode = this.formData.goodTypeCode, clientRequestDate = this.formData.clientRequestDate, secondClientRequestDate = this.formData.secondClientRequestDate, startTime = this.formData.startTime, endTime=this.formData.endTime;
			// const isManage=orgRoleName === 'WAREHOUSE';
			const typeMap = {
				cancel: {
					show: true,
					alert: "warning",
					title: "Cancel",
					desc: "If cancel, you need to create a new reservation, do you want to continue？",
					params: {
						id,
						orgRoleName
					},
					ajaxRequest: HttpCancelBespeak,
				},
				//管理员
				manageCancel: {
					show: true,
					alert: "warning",
					title: "Cancel",
					showDesc: false,
					params: {
						id,
					},
					ajaxRequest: HttpManageCancelBespeak,
					formdata: [
						{
							label: "Remark",
							tag: "vTextarea",
							labelWidth: "auto",
							key: "remark",
							span: 24,
						}
					]
				},
				confirm: {
                    // 需要换成组件形式
					show: true,
					width: 660,
					alert: "success",
					title: "Approve(Allow Delivery)",
					showDesc: false,
					params: {
						id,
						orgRoleName,
                        clientRequestDate,
                        secondClientRequestDate,
                        startTime,
                        endTime,

					},
                    component:'compApprove',
                    showFooter:false,
                    on:{
                        'on-update':()=>{
                            this.getDetail()
                        }
                    }
                },
                pickup:{
                    show: true,
					width: 460,
					alert: "warning",
					title: "Empty Container Pick up",
					showDesc: false,
					params: {
						id,
					},
					ajaxRequest: HttpPickupDate,
					formdata: [
						{
							tag: "vDatepicker",
							key: "obtainEmptyContainerDate",
							span: 24,
							label: "Empty Container Pick up Date",
							formItem: {
								labelWidth: 190
                            },
                            props: {
								format: 'yy-mm-dd',
							},
						},
						{
							tag: "vTextarea",
							key: "remark",
							span: 24,
							label: "Remark",
							required: false,
							formItem: {
								labelWidth: 190
							},
						}
					]
                },
				reject: {
					show: true,
					width: 460,
					alert: "error",
					title: "Reject(Delivery not allowed)",
					showDesc: false,
					params: {
						id,
						orgRoleName,
					},
					ajaxRequest: HttpRefuseBespeak,
					formdata: [
						{
							tag: "vTextarea",
							key: "refuseRemark",
							span: 24,
							label: "Remark",
						}
					]
				},
				discharge: {
					show: true,
					width: 460,
					alert: "primary",
					title: "Unloaded",
					showDesc: false,
					params: {
						id,
						orgRoleName,
					},
					ajaxRequest: HttpDischargeBespeak,
					formdata: (goodTypeCode === 'LTL' || goodTypeCode === 'Express') ? [
						{
							tag: "vTextarea",
							key: "remark",
							span: 24,
							label: "Remark",
							required: false,
						}
					] : [
							{
								tag: "vDatepicker",
								key: "containerEmptyTime",
								span: 24,
                                label: "Container Empty Time",
                                props: {
                                    format: "yy-mm-dd",
                                    confirm: false
                                },
								formItem: {
									labelWidth: 160
								},
							},
							{
								tag: "vTextarea",
								key: "remark",
								span: 24,
								label: "Remark",
								required: false,
								formItem: {
									labelWidth: 160
								},
							}]
				},
                arrived: {
					show: true,
					width: 460,
					alert: "primary",
					title: "Arrived",
					showDesc: false,
					params: {
						id,
						orgRoleName,
					},
					ajaxRequest: HttpArrivedBespeak,
					formdata: [{
                            tag: "vDatepicker",
                            key: "arriveDate",
                            span: 24,
                            label: "Actual Arrival Time",
                            props: {
                                format: "yy-mm-dd",
                                confirm: false
                            },
                            formItem: {
                                labelWidth: 160
                            },
                        },
                        {
                            tag: "vTextarea",
                            key: "remark",
                            span: 24,
                            label: "Remark",
                            required: false,
                            formItem: {
                                labelWidth: 160
                            },
                        }]
				},
				update: {
					show: true,
					width: 460,
					alert: "primary",
					title: "Update",
					showDesc: false,
					params: {
						id,
						orgRoleName,
					},
					ajaxRequest: HttpBespeakUpdate,
					formdata: [
						{
							tag: "vDatepicker",
							key: "reserveInboundDate",
							span: 24,
                            label: "Scheduled Delivery Time",
                            props: {
                                format: "yy-mm-dd",
                                confirm: false
                            },
							formItem: {
								labelWidth: 160
							},
						},
						{
							tag: "vInput",
							key: "loadingDock",
							span: 24,
							label: "Loading Dock",
							required: false,
							formItem: {
								labelWidth: 160
							},
						},
						{
							tag: "vTextarea",
							key: "approvalRemark",
							span: 24,
							label: "Remark",
							required: false,
							formItem: {
								labelWidth: 160
							},
						}
					]
				},
				submit: {
					show: true,
					alert: "primary",
					title: "Submit",
					params: {
						orgRoleName,
						...this.formData
					},
					ajaxRequest: HttpSubBespeak,
				},
				Delivered: {
					show: true,
					alert: "info",
					width: 'middle',
					title: "Delivered Date",
					params: { id },
					ajaxRequest: HttpDeliverBespeak,
					showDesc: false,
					formdata: [
						{
							label: "Delivered Date",
							tag: "vDatepicker",
							key: "deliveredDate",
							span: 24,
							props: {
								format: 'yy-mm-dd',
							},
						},
						{
							label: "Remark",
							tag: "vTextarea",
							key: "remark",
							span: 24,
							required: false,

						}
					]
				},
			}
			this.operate = typeMap[type];
            
		},
	}
};
</script>
